export default {
  wechatWebsiteAppId: process.env.wechatWebsiteAppId,
  commonServiceConfKey: process.env.commonServiceConfKey,
}


// WEBPACK FOOTER //
// ./src/static/config.js